module.exports = __webpack_public_path__ + "img/NPL.74303610.svg";